import { axiosClient } from '../api/proxy/AxiosClient';

const base = '/outwrite';

export const OutwriteApi = {
  list: () => axiosClient.get(base).then((r) => r.data),
  get: (taskId) => axiosClient.get(`${base}/${taskId}`).then((r) => r.data),
  getWorkspace: (taskId) =>
    axiosClient.get(`${base}/workspace/${taskId}`).then((r) => r.data),
  listLlmModels: () =>
    axiosClient.get(`${base}/llm/models`).then((r) => r.data),
  createLlmModel: (id, mode, label) =>
    axiosClient
      .post(`${base}/llm/models`, { id, mode, label })
      .then((r) => r.data),
  deleteLlmModel: (id, mode) =>
    axiosClient
      .delete(`${base}/llm/models`, { params: { id, mode } })
      .then((r) => r.data),
  getLlmSettings: () =>
    axiosClient.get(`${base}/llm/settings`).then((r) => r.data),
  setLlmSettings: (modelId, mode) =>
    axiosClient
      .put(`${base}/llm/settings`, { modelId, mode })
      .then((r) => r.data),
  saveRubrics: (taskType, { created, changed, deleted }) =>
    axiosClient
      .put(`${base}/rubrics/${taskType}`, { created, changed, deleted })
      .then((r) => r.data),
  exportRubricsCatalog: () =>
    axiosClient.get(`${base}/rubrics-catalog`).then((r) => r.data),
  listRubricsSeverities: () =>
    axiosClient.get(`${base}/rubrics-severity`).then((r) => r.data),
  createRubricsSeverity: (value) =>
    axiosClient
      .post(`${base}/rubrics-severity`, { value })
      .then((r) => r.data),
  deleteRubricsSeverity: (value) =>
    axiosClient
      .delete(`${base}/rubrics-severity`, { params: { value } })
      .then((r) => r.data),
  answer: (text, timeoutMs) =>
    axiosClient
      .post(`${base}/answer`, { text }, { timeout: timeoutMs })
      .then((r) => r.data),
  check: (text, taskId, timeoutMs, rubrics, promptRules) => {
    const body = { text, taskId };
    if (rubrics) body.rubrics = rubrics;
    if (promptRules != null && promptRules !== '') body.promptRules = promptRules;
    return axiosClient
      .post(`${base}/check`, body, { timeout: timeoutMs })
      .then((r) => r.data);
  },
  listCheckLogs: (params) =>
    axiosClient.get(`${base}/check-logs`, { params }).then((r) => r.data),
  listCheckLogActors: () =>
    axiosClient.get(`${base}/check-log-actors`).then((r) => r.data),
  saveCheckAnnotations: (checkLogId, annotations) =>
    axiosClient
      .put(`${base}/check-logs/${checkLogId}/annotations`, { annotations })
      .then((r) => r.data),
  createTestCase: (checkLogId, { title, annotations } = {}) => {
    const body = { checkLogId };
    if (title != null && title !== '') body.title = title;
    if (annotations) body.annotations = annotations;
    return axiosClient.post(`${base}/test-cases`, body).then((r) => r.data);
  },
  listTestCases: (params) =>
    axiosClient.get(`${base}/test-cases`, { params }).then((r) => r.data),
  getTestCase: (id) =>
    axiosClient.get(`${base}/test-cases/${id}`).then((r) => r.data),
  updateTestCase: (id, body) =>
    axiosClient.put(`${base}/test-cases/${id}`, body).then((r) => r.data),
  deleteTestCase: (id) =>
    axiosClient.delete(`${base}/test-cases/${id}`).then((r) => r.data),
  createTestRun: (testCaseIds, timeoutMs) =>
    axiosClient
      .post(
        `${base}/test-runs`,
        { testCaseIds },
        timeoutMs ? { timeout: timeoutMs } : undefined,
      )
      .then((r) => r.data),
  listTestRuns: (params) =>
    axiosClient.get(`${base}/test-runs`, { params }).then((r) => r.data),
  getTestRun: (id) =>
    axiosClient.get(`${base}/test-runs/${id}`).then((r) => r.data),
  getCheckPrompt: (taskType) =>
    axiosClient.get(`${base}/check-prompt/${taskType}`).then((r) => r.data),
  saveCheckPrompt: (taskType, rulesText) =>
    axiosClient
      .put(`${base}/check-prompt/${taskType}`, { rulesText })
      .then((r) => r.data),
  saveToFinds: (taskId, toFinds) =>
    axiosClient
      .put(`${base}/workspace/${taskId}/to-finds`, { to_finds: toFinds })
      .then((r) => r.data),
};
